import React from "react"
import "../assets/css/aboutconference.css"

export default function AboutConference() {
  return (
    <div className="about-container">
      <h1 className="about-heading">About Conference</h1>
      <div className="about-para-container">
        <p>
        The 1<sup>st</sup> International Conference on Green Hydrogen for Global Decarbonisation is 
        being organized by the Department of Petroleum Engineering, School of Energy Technology, 
        Pandit Deendayal Energy University (PDEU), Gujarat-India. PDEU is one of the leading research and academic institutes 
        in the energy sector and allied branches of engineering. Green Hydrogen possesses the immense potential to become a vital component of 
        the energy mix. It is expected to become a $12-15 trillion global industry by 2050. 
        It has also captured a clear investor interest at the 1<sup>st</sup> International Conference 
        on Green Hydrogen for Global Decarbonization.
        </p>
        <p>
        This two-day conference will bring together academicians, policymakers, regulators, innovators, oil 
        and gas companies, infrastructure companies, technology providers, industry experts 
        and investors to present their perspectives and provide stimulus in shaping the 
        future of green hydrogen. It will provide a global platform for leading developers
        to showcase their innovations and technologies and explore investor interest in financing 
        their projects.
        </p>
        <p>The Prime Minister's Independence Day speech on August 15<sup>th</sup>, 2021, signalling the 
        launch of the National Hydrogen Mission, attests to India's intent to be a global hub for
        green hydrogen. As PM Modi's speech outlines, not only will green hydrogen be the basis of 
        growth through green jobs but it will also set an example for the world towards a clean energy 
        transition. The conference will provide a platform for expelling the latest development in 
        equipment, compressors, devices, products, technologies, and services in the hydrogen industry.</p>
      </div>
    </div>
  )
}
